<template>
  <div id="app">
    <LayoutHeader v-if="showLayout"/>
    <transition :name="transitionName" mode="out-in">
      <router-view/>
    </transition>
    <LayoutFooter v-if="showLayout"/>
    <BackToTop/>
  </div>
</template>

<script>
import LayoutHeader from '@/components/LayoutHeader.vue'
import LayoutFooter from '@/components/LayoutFooter.vue'
import BackToTop from '@/components/BackToTop.vue'

export default {
  name: 'App',
  components: { LayoutHeader, LayoutFooter, BackToTop },
  data() {
    return {
      transitionName: 'fade-transform'
    }
  },
  computed: {
    showLayout() {
      return this.$route.meta.layout !== 'blank'
    }
  },
  watch: {
    '$route'(to, from) {
      if (!from || !from.name) {
        this.transitionName = 'fade-transform'
        return
      }
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth > fromDepth ? 'slide-left' : 'slide-right'
    }
  }
}
</script>

<style>
/* ---- Page Transitions ---- */
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.35s ease;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateY(12px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(30px);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
<template>
  <div id="app">
    <LayoutHeader v-if="showLayout"/>
    <router-view/>
    <LayoutFooter v-if="showLayout"/>
  </div>
</template>

<script>
import LayoutHeader from '@/components/LayoutHeader.vue'
import LayoutFooter from '@/components/LayoutFooter.vue'
export default {
  name: 'App',
  components: { LayoutHeader, LayoutFooter },
  computed: {
    showLayout() { return this.$route.meta.layout !== 'blank' }
  }
}
</script>
